module.exports = __webpack_public_path__ + "img/about-company-04.91b91997.jpeg";